var files = require.context('./Filters', false, /\.js$/)
var modules = {}
files.keys().forEach(function (key) {
  var m = /^.\/(\S{1,})Filter\.js$/.exec(key)
  if (m) {
    modules[m[1]] = files(key).default
  }
})
export default modules
